import httpClient from '../services/httpClient'
import { API_ROOT } from '../constants'

// Non-secret CDN configuration only — no credentials in the browser
const S3_ENDPOINTS = {
  'ap-south-1': {
    cdn: `https://${S3_BUCKET}.${S3_CDN_ASIA}`,
  },
  default: {
    cdn: `https://${S3_BUCKET}.${S3_CDN_ASIA}`,
  },
}

/**
 * Upload a file to S3 via the backend (multipart/form-data).
 * AWS credentials stay on the server — never in the browser bundle.
 */
export const putObject = async (params) => {
  const formData = new FormData()
  formData.append('file', params.Body, params.Key)
  formData.append('key', params.Key)

  const { data } = await httpClient.post(
    `${API_ROOT}/storage/upload`,
    formData
  )

  return data.cdnUrl
}

/**
 * Delete an S3 object via the backend.
 */
export const deleteObject = async (params, _region = 'default') => {
  await httpClient.post(
    `${API_ROOT}/storage/delete-object`,
    new URLSearchParams({ key: params.Key })
  )
  return params.Key
}

export const getRegionFromUrl = (url) =>
  Object.keys(S3_ENDPOINTS)
    .filter(region => region !== 'default')
    .find(region => url.startsWith(S3_ENDPOINTS[region].cdn))

export default {
  putObject,
  deleteObject,
  getRegionFromUrl,
}

